module.exports = __webpack_public_path__ + "static/media/icon-win.0830e2ba.svg";